import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { IconButton, Typography, Box, Divider } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomButton from "../button/CustomButton";

export default function ConfirmationModal({
  open,
  setOpen,
  handleConfirm,
  confirmationTitle,
  confirmationDesc,
  confirmText,
  cancleText,
  data,
  render,
}) {
  const handleClose = (value) => {
    handleConfirm(value, data);
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="confirmation-dialog-container"
      onClose={() => handleClose(false)}
      disableScrollLock={false}
      PaperProps={{
        sx: {
          borderRadius: "14px",
          overflow: "hidden",
          minWidth: "360px",
          maxWidth: "480px",
          boxShadow: "0 20px 60px rgba(0,0,0,0.16)",
        },
      }}
    >
      {/* Header */}
      {!!confirmationTitle && (
        <DialogTitle
          component="div"
          id="alert-dialog-title"
          sx={{ p: 0 }}
        >
          <Box className="confirmation-dialog-header">
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 700,
                fontFamily: "Poppins, sans-serif",
                color: "#1a1a2e",
                lineHeight: 1.4,
              }}
            >
              {confirmationTitle}
            </Typography>
            <IconButton
              size="small"
              onClick={() => handleClose(false)}
              sx={{
                color: "#64748b",
                ml: 1,
                "&:hover": { background: "#f1f5f9", color: "#0f172a" },
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
          <Divider />
        </DialogTitle>
      )}

      {/* Body */}
      {(!!confirmationDesc || !!render) && (
        <DialogContent sx={{ px: "20px", py: "16px" }}>
          {!!confirmationDesc && (
            <DialogContentText id="alert-dialog-description">
              <Typography
                sx={{
                  fontSize: "14px",
                  fontFamily: "Poppins, sans-serif",
                  color: "#ef4444",
                  fontWeight: 500,
                  lineHeight: 1.6,
                }}
              >
                {confirmationDesc}
              </Typography>
            </DialogContentText>
          )}
          {render && render()}
        </DialogContent>
      )}

      {/* Footer */}
      <Divider />
      <DialogActions sx={{ px: "20px", py: "14px", gap: "10px", justifyContent: "flex-end" }}>
        <CustomButton
          buttonVariant="secondary"
          borderRadius="primary"
          isSelected={true}
          buttonText={confirmText}
          typoVariant="xxxsSize"
          extraButtonStyle={{
            minWidth: "110px",
            height: "40px",
            backgroundColor: "#ef4444 !important",
            borderRadius: "8px",
            textTransform: "none",
            fontWeight: 600,
          }}
          typoClass="font-w-500"
          colorVariant="primary"
          onClick={() => handleClose(true)}
        />
        <CustomButton
          buttonVariant="secondary"
          borderRadius="primary"
          isSelected={true}
          buttonText={cancleText}
          typoVariant="xxxsSize"
          extraButtonStyle={{
            minWidth: "110px",
            height: "40px",
            backgroundColor: "#475569 !important",
            borderRadius: "8px",
            textTransform: "none",
            fontWeight: 600,
          }}
          typoClass="font-w-500"
          colorVariant="primary"
          onClick={() => handleClose(false)}
        />
      </DialogActions>
    </Dialog>
  );
}

ConfirmationModal.defaultProps = {
  open: false,
  setOpen: () => {},
  handleConfirm: () => {},
  confirmationTitle: "Alert!!",
  confirmationDesc: "Are you sure you want to perform this action?",
  confirmText: "Confirm",
  cancleText: "Cancel",
  render: null,
};
